import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AuthCallback from "@/components/AuthCallback";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import TradesList from "@/pages/TradesList";
import AddTrade from "@/pages/AddTrade";
import EditTrade from "@/pages/EditTrade";
import Settings from "@/pages/Settings";
import Accounts from "@/pages/Accounts";
import SignalsUpload from "@/pages/SignalsUpload";
import SignalsDashboard from "@/pages/SignalsDashboard";
import Analytics from "@/pages/Analytics";
import Strategies from "@/pages/Strategies";
import TradeSignals from "@/pages/TradeSignals";
import SpeedBot from "@/pages/SpeedBot";

// Router component that handles auth callback detection
function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check URL fragment for session_id synchronously during render
  // This prevents race conditions by processing new session_id FIRST before checking existing session_token
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      {/* Public route - Landing page */}
      <Route path="/" element={<Landing />} />
      
      {/* Protected routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/analytics"
        element={
          <ProtectedRoute>
            <Layout>
              <Analytics />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/trades"
        element={
          <ProtectedRoute>
            <Layout>
              <TradesList />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/add-trade"
        element={
          <ProtectedRoute>
            <Layout>
              <AddTrade />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/edit-trade/:tradeId"
        element={
          <ProtectedRoute>
            <Layout>
              <EditTrade />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/signals"
        element={
          <ProtectedRoute>
            <Layout>
              <SignalsUpload />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/signals-dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <SignalsDashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <Settings />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounts"
        element={
          <ProtectedRoute>
            <Layout>
              <Accounts />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/strategies"
        element={
          <ProtectedRoute>
            <Layout>
              <Strategies />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/trade-signals"
        element={
          <ProtectedRoute>
            <Layout>
              <TradeSignals />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/speedbot"
        element={
          <ProtectedRoute>
            <Layout>
              <SpeedBot />
            </Layout>
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
        </AuthProvider>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
